export const EmailIcon = ({ fillColor = '#004dbc' }) => {
  return (
    <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Group 7440" id="Group_7440" transform="translate(-700 -287)">
        <g data-name="Group 5932" id="Group_5932" transform="translate(702 291)">
          <path
            d="M1.5,8.67v6.579a2.3,2.3,0,0,0,2.3,2.3H15.3a2.3,2.3,0,0,0,2.3-2.3V8.67l-6.846,4.212a2.3,2.3,0,0,1-2.411,0Z"
            data-name="Layout 3354"
            fill={fillColor}
            id="Layout_3354"
            transform="translate(-1.5 -4.897)"
          />
          <path
            d="M17.6,6.172V6.05a2.3,2.3,0,0,0-2.3-2.3H3.8a2.3,2.3,0,0,0-2.3,2.3v.121l7.449,4.584a1.15,1.15,0,0,0,1.205,0Z"
            data-name="Layout 3355"
            fill={fillColor}
            id="Layout_3355"
            transform="translate(-1.5 -3.75)"
          />
        </g>
        <rect
          data-name="Rectangle 4125"
          fill="none"
          height="20"
          id="Rectangle_4125"
          transform="translate(700 287)"
          width="20"
        />
      </g>
    </svg>
  );
};
